// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","button":"button-1-9i2","button_add":"button_add-3XCFA","button_change":"button_change-12vtp","header":"header-2-kEp"};